/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/SolitaireGameMode',['lodash'], function (_){
    return {
        Spider: 0,
        FreeCell: 1,
        Pyramid: 2,
        TriPeaks: 3,
        Klondike: 4,
        Unknown: 5,
        DailyChallenge: 6,
        StarClub: 7,
        getModeById: function(id) {
            var name = '';
            _.each(this, function(modeId, modeKey) {
                if(modeId == id) {
                    name = modeKey;
                }
            });
            return name;
        },
        getModeNameByIndex: function(index) {
            var name = '';
            _.each(this, function(value, key) {
                if(value === index) {
                    name = key;
                }
            });
            return name;
        }
    }
});

